import React, {memo, useEffect} from 'react';
import { GET_CMS_BLOCKS } from '../../commonQueries';
import {useQuery} from "@apollo/client";
import {returnValidJson} from "../../components/PageRenderer/PageRenderer";
import RootComponent from "../../renderComponents/RootComponent/RootComponent";
import './CmsBlock.scss'
const CmsBlock = ({identifier}) => {
    const { data, loading, error } = useQuery(GET_CMS_BLOCKS, {
        variables: {
            identifiers: identifier,
        },
        fetchPolicy: 'cache-first',
        skip: !identifier || typeof identifier !== 'string' || identifier.trim() === '',
    });

    if (!identifier) return null;
    if (loading) return null;

    const json = data && data.cmsBlocks.items[0].content_json && returnValidJson(data.cmsBlocks.items[0].content_json);
    return <div className="cms_block">{data && <RootComponent children={json} />}</div>;
}

export default memo(CmsBlock);